<template>
  <ga-image
    :src="srcInternal"
    :sources="sourcesInternal"
    :lazy="lazy"
    v-bind="$attrs"
  />
</template>

<script src="./image-responsive.script.js" />
